export default string => string[0].toUpperCase() + string.substring(1);
